import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages as m } from '../../../constants';
import * as D from '../../../deps';

const BackstagePodcastProgramSubheaderLarge = props => {
  if (!props.publisherName) return null;

  return (
    <div className='BackstagePodcastProgramSubheaderLarge'>
      <FormattedMessage {...m.by} /> {props.publisherName}
    </div>
  );
};

BackstagePodcastProgramSubheaderLarge.propTypes = {
  publisherName: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const programAnnotation = D.getAnnotationsById(state, ownProps.programId);

  return {
    publisherName: D.Utils.Core.getFromMap(programAnnotation, 'publisherName'),
  };
}

export default connect(mapStateToProps)(BackstagePodcastProgramSubheaderLarge);
